import type { ReactNode } from "react";

import type { SearchHit } from "./types";

// Must match App\Controller\API\GlobalSearchController::HIGHLIGHT_PRE_TAG /
// HIGHLIGHT_POST_TAG — non-HTML markers, so we can safely split on them
// instead of trusting/injecting raw HTML from Meilisearch.
const PRE = "\u0001";
const POST = "\u0002";

function highlightText(value: unknown): ReactNode {
  if ("string" !== typeof value) {
    return undefined;
  }

  if (!value.includes(PRE)) {
    return value;
  }

  const segments = value.split(PRE);
  const nodes: ReactNode[] = [segments[0]];

  for (let i = 1; i < segments.length; i++) {
    const [match, ...rest] = segments[i].split(POST);

    nodes.push(<mark key={i}>{match}</mark>);

    const remainder = rest.join(POST);

    if (remainder) {
      nodes.push(remainder);
    }
  }

  return nodes;
}

export function getHighlightedField(hit: SearchHit, field: string): ReactNode {
  const formatted = hit._formatted?.[field];

  return highlightText("string" === typeof formatted ? formatted : hit[field]);
}

export function getHighlightedTitle(hit: SearchHit): ReactNode {
  const field =
    "string" === typeof hit.displayName && hit.displayName
      ? "displayName"
      : "string" === typeof hit.name && hit.name
        ? "name"
        : null;

  return field ? getHighlightedField(hit, field) : `#${hit.id}`;
}
